export default __webpack_public_path__ + "static/media/postSuvinil2.42a82f0f.gif";